import { ReactElement } from 'react';
import classnames from 'classnames';

import { CheckableCardElement } from '@hh.ru/magritte-ui-checkable-card/CheckableCardElement';
import { Action } from '@hh.ru/magritte-ui-tree-selector/Action';
import { TreeSelectorItemBase } from '@hh.ru/magritte-ui-tree-selector/TreeSelectorItemBase';
import { AdditionalDefault, TreeModel } from '@hh.ru/magritte-ui-tree-selector/collection/types';
import { RenderItem } from '@hh.ru/magritte-ui-tree-selector/types';

interface MobileItemProps<Additional extends AdditionalDefault> {
    item: TreeModel<Additional>;
    singleChoice?: boolean;
    isSelectable?: boolean;
    isSelected: boolean;
    isDisabled: boolean;
    onChange: (id: string, isSelected: boolean) => void;
    renderItem?: RenderItem<Additional>;
    isSearch: boolean;
    parentId?: string;
}

export const MobileItem = <Additional extends AdditionalDefault>({
    item,
    isSelected,
    singleChoice,
    isSelectable,
    isDisabled,
    onChange,
    isSearch,
    parentId,
    renderItem = TreeSelectorItemBase,
}: MobileItemProps<Additional>): ReactElement => {
    const input = isSelectable ? (
        <Action selected={isSelected} onChange={onChange} id={item.id} singleChoice={singleChoice} />
    ) : undefined;
    return (
        <CheckableCardElement
            padding={16}
            borderRadius={12}
            Element="label"
            flexible
            checked={isSelected}
            data-qa={classnames('tree-selector-item', `tree-selector-item-${item.id}`, {
                [`tree-selector-child-${parentId}`]: parentId,
            })}
        >
            {renderItem({ input, item, isSearch, isXS: true, disabled: isDisabled })}
        </CheckableCardElement>
    );
};
